import React from "react";
import classes from "./cardTitle.module.css";

const CardTitle = ({ cardTitle }) => {
  return <div className={classes.cardTitle}>{cardTitle}</div>;
};

export default CardTitle;
